import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  InputAdornment,
  Typography,
  Button,
  FormHelperText,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useLocation } from "react-router-dom";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import { Formik, Form, Field, ErrorMessage } from "formik";
import {
  NRIValidationEmailAPICall,
  locationCheckAPICall,
} from "../shared/APICalls";
import { ISendEmail, IValidateEmail } from "../shared/dtos";
import routesData from "../shared/routes.json";
import YourDetailsStyles from "../pages/Styles/YourDetails.module.scss";
import YourdetailsImage from "../Components/assets/Images/newLeftImage.svg";
import googleImage from "../Components/assets/Images/goggle.png";
import ContinueWithGoogle from "../Components/ContinueWithGoogle/ContinueWithGoogle";
import SnackBar from "../Components/SnackBars/SnackBar";
import mobileviewimage from "../Components/assets/Images/mobileviewgiftbox.svg";
import { browserName } from "react-device-detect";
import firstockLogo from "../Components/assets/Images/firstockLogoBadge.svg";
import emailicon from "../Components/assets/Images/emailicon.svg";
import axios from "axios";

export default function YourDetails() {
  const navigate = useNavigate();
  const pathName = useLocation().pathname;

  const [message, setMessage] = useState<any>("");
  const [loading, setloading] = useState(false);
  const [IPAddress, setIPAddress] = useState("");
  const [loadingcontent, setloadingcontent] = useState(true);
  const [latitude, setlatitude] = useState("");

  const navigationData = routesData;

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      setloadingcontent(false);
    }, 1000);
    // checkUserLoggedIn(navigate);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchIPAddress = async () => {
      try {
        const response = await axios.get(
          "https://ipapi.co/json/?key=jmJoC4fsM8a1wzvqBWZsEBfRiXtQqsTtz4XdAXaDb27gq2s9QJ"
        );
        // setIPAddress(response.data);
        setIPAddress(response.data?.ip);
      } catch (err: any) {}
    };
    fetchIPAddress();
  }, []);

  useEffect(() => {
    if (IPAddress !== "") {
      locationCheckAPICall()
        .then((response: any) => {
          if (response.data.data) {
            setlatitude(response.data.data.latitude);
            sessionStorage.setItem("latitude", response.data.data.latitude);
            sessionStorage.setItem("longitude", response.data.data.longitude);
          }
        })
        .catch((error: any) => {});
    }
  }, [IPAddress]);

  function sendEmailAddress(emailid: any) {
    let obj: IValidateEmail = {
      email: emailid,
    };
    NRIValidationEmailAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        console.log(responseData, "response");
        sessionStorage.setItem("emailID", emailid);
        setloading(false);

        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);
        // console.log("error", error);

        setMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.message
        );
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  }

  function validateName(value: any) {
    let error: any;
    if (!value) {
      error = "Name Required";
    } else if (!/^[a-zA-Z\s]{1,50}$/.test(value)) {
      error = "Extra characters not allowed";
    }
    return error;
  }

  function validateEmail(value: any) {
    let error: any;
    if (!value) {
      error = "Email Required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
      error = "Invalid email address";
    } else if (value.length > 75) {
      error = "Not a valid email address";
    }
    return error;
  }

  return (
    <>
      <SnackBar message={message} />
      <div className={YourDetailsStyles.wrapper}>
        <div className={YourDetailsStyles.RightContainer}>
          <div className={YourDetailsStyles.topLogoSection}>
            <img src={firstockLogo} className={YourDetailsStyles.topLogo} />
          </div>
          <div className={YourDetailsStyles.contentSection}>
            <div className={YourDetailsStyles.headerSection}>
              <p className={YourDetailsStyles.signup}>
                Whats your Email address?
              </p>
              <p className={YourDetailsStyles.subText}>
                All Firstock account related information will be sent to this
                address.
              </p>
            </div>

            <Formik
              initialValues={{
                // name: "",
                email: "",
              }}
              onSubmit={(values) => {
                //  console.log(values);
                setloading(true);
                // setemailAddress(values.email);
                sendEmailAddress(values.email);
              }}
            >
              {({ errors, touched, handleChange, values, handleSubmit }) => (
                <Form
                  onKeyDown={(event) => {
                    event.code === "Enter" ||
                      (event.code === "NumpadEnter" && handleSubmit());
                    // event.code.includes("Enter") && handleSubmit()
                  }}
                  style={{ width: "100%" }}
                >
                  <div className={YourDetailsStyles.feildsWrapper}>
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        marginTop: "10px",
                      }}
                    >
                      <Field
                        name="email"
                        validate={validateEmail}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            className={YourDetailsStyles.textfeild}
                            id="outlined-basic"
                            placeholder="Email Address"
                            variant="outlined"
                            sx={{
                              fieldset: {
                                borderColor: "#E5E7EB",
                                borderRadius: "100px",
                              },
                            }}
                            inputProps={{
                              sx: {
                                "&::placeholder": {
                                  color: "#111827",
                                  fontWeight: 400,
                                  fontStye: "normal",
                                },
                              },
                            }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <img
                                    src={emailicon}
                                    style={{ marginLeft: "10px" }}
                                  />
                                </InputAdornment>
                              ),
                              maxLength: 50,
                              sx: {
                                paddingLeft: "10px",
                              },
                            }}
                          />
                        )}
                      />
                    </div>
                    <div
                      style={{
                        color: "#d32f2f",
                        fontSize: "12px",
                        height: "25px",
                        padding: "5px 0px 0px 0px",
                        textAlign: "center",
                      }}
                    >
                      {errors.email && touched.email && errors.email}
                    </div>

                    <div className={YourDetailsStyles.buttonSection}>
                      {values.email ? (
                        <LoadingButton
                          variant="contained"
                          type="submit"
                          loading={loading}
                          id="yourDetailsContinueButton"
                          className={YourDetailsStyles.button}
                          onClick={() => {
                            handleSubmit();
                          }}
                        >
                          Continue
                        </LoadingButton>
                      ) : (
                        <Button
                          variant="contained"
                          disabled
                          className={YourDetailsStyles.button}
                        >
                          Continue
                        </Button>
                      )}
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
}
